import { render, staticRenderFns } from "./HomePopups.vue?vue&type=template&id=cd71f006"
import script from "./HomePopups.vue?vue&type=script&lang=js"
export * from "./HomePopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports